<mat-form-field fxFlex="100" class="second-input-style">
  <mat-label>{{ matLabel }}</mat-label>
  <mat-spinner
    class="spinner-prefix-padding"
    matPrefix
    color="accent"
    [diameter]="30"
    *ngIf="spinnerLoading"
  ></mat-spinner>
  <mat-select
    [formControl]="customerControl"
    [multiple]="multiSelect"
    [disabled]="isDisabled"
  >
    <mat-option>
      <ngx-mat-select-search
        noEntriesFoundLabel="No matching customer found"
        #searchCustomerName
        placeholderLabel="Search by customer name..."
      >
      </ngx-mat-select-search>
    </mat-option>
    <mat-checkbox
      *ngIf="optionAll"
      color="primary"
      class="mat-option"
      (click)="$event.stopPropagation()"
      (change)="toggleAllServices($event)"
    >
      All
    </mat-checkbox>
    <mat-option
      *ngFor="
        let customer of customers
          | selectSearch : searchCustomerName.value : searchCriteria
      "
      [value]="customer.CustomerID || customer.customerId"
    >
      {{ customer.CustomerName || customer.customerName }}
    </mat-option>
  </mat-select>
</mat-form-field>
